import { Router } from '@angular/router';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Logger } from 'angular2-logger/core';
import { ScheduleService } from '../../admin/schedule/schedule.service';
import { SharedService } from '../shared.service';
import { UserService } from '../../admin/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';


//  Jquery imports
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-schedule-new',
  templateUrl: './schedule-new.component.html',
  styleUrls: ['../../admin/admin/admin.component.scss','./schedule-new.component.scss'],
  providers: [UserService]
})

export class ScheduleNewComponent implements OnInit {

  @Output() mostrarListaOut = new EventEmitter<any>();
  @Input() admin_schedules: boolean;


  //public load: boolean;
  public form: FormGroup;
  public form2: FormGroup;
  public current_day: string;
  public schedule: any = {};
  public schedulesList: any;
  public scheduleName = [];
  public types: any[];
  public selectedValue: any;

  constructor(
    private _scheduleService: ScheduleService,
    private _sharedService: SharedService,
    private _router: Router,
    public toastr: ToastsManager,
    private logger: Logger,
    private fb: FormBuilder,
    private userService: UserService,
    private spinner: NgxSpinnerService
  ) {

    let data = {
      auth_token: this._sharedService.getCookie('auth_token')
    };
    this.getListSchedule(data);
    this.getSchedulesTypes(data);
  }


  ngOnInit() {
    this.inicializedObject();
  }


  getListSchedule(data: any) {
    //this.load = true;
    this.spinner.show();
    this._scheduleService.newScheduleList(data).subscribe(
      data => {
        this.schedulesList = data.data.data;
        //this.load = false;
        this.spinner.hide();
      });
  }

  onNew() {

    for (let i = 0; i < this.schedulesList.length; i++) {

      if (this.schedulesList[i].name !== this.form.value.name) {
        this.scheduleName.push(this.schedulesList[i].name);
      }
    }

    let aux = [];

    if (this.schedule.monday.length > 0) {
      aux.push({ day_week: 1, shift: this.schedule.monday });
    }
    if (this.schedule.tuesday.length > 0) {
      aux.push({ day_week: 2, shift: this.schedule.tuesday });
    }
    if (this.schedule.wednesday.length > 0) {
      aux.push({ day_week: 3, shift: this.schedule.wednesday });
    }
    if (this.schedule.thursday.length > 0) {
      aux.push({ day_week: 4, shift: this.schedule.thursday });
    }
    if (this.schedule.friday.length > 0) {
      aux.push({ day_week: 5, shift: this.schedule.friday });
    }
    if (this.schedule.saturday.length > 0) {
      aux.push({ day_week: 6, shift: this.schedule.saturday });
    }
    if (this.schedule.sunday.length > 0) {
      aux.push({ day_week: 7, shift: this.schedule.sunday });
    }

    if (this.scheduleName.length === this.schedulesList.length) {

      this.scheduleName = [];

      if (aux.length > 0) {

        //this.load = true;
        this.spinner.show();

        let data = {
          auth_token: this._sharedService.getCookie('auth_token'),
          name: this.form.value.name,
          type_id: this.form.value.selectType,
          schedules: aux
        };

        this.logger.log(data);
        this._scheduleService.newSchedule(data).subscribe(
          data => {
            this.logger.log(data);
            if (data.status) {
              this.toastr.success('¡El horario ha sido creado! ', ' ¡Éxito!');
              if (this.admin_schedules) {
                this.mostrarListaOut.emit(data.data);
              }
            } else {
              this.toastr.error(data.message, 'Error');
            }
            //this.load = false;
            this.spinner.hide();
          },
          error => {
            this.toastr.error('Ocurrió un error, inténtalo de nuevo ', ' Error');
            this.logger.log(error);
            //this.load = false;
            this.spinner.hide();
          }
        );
      } else {
        $('#dontCreate').modal('toggle');
      }

    } else {
      this.scheduleName = [];
      $('#dontCreateName').modal('toggle');
    }

  }

  onNewShift() {
    /// creates a new shift

    //this.load = true;
    this.spinner.show();
    var shift = {
      time_start: this.form2.value.start_hour + ':' + this.form2.value.start_min + ':00',
      time_end: this.form2.value.end_hour + ':' + this.form2.value.end_min + ':00'
    }
    var append = true;

    for (let i = 0; i < this.schedule[this.current_day].length; i++) { // searchs for duplicates

      if (this.schedule[this.current_day][i].time_start == shift.time_start
        && this.schedule[this.current_day][i].time_end == shift.time_end) {
        append = false;
        break;
      } else if (this.schedule[this.current_day][i].time_start == shift.time_start
        && this.schedule[this.current_day][i].time_end !== shift.time_end) {

        $('#dontInsertTurn').modal('toggle');
        append = false;
        break;

      } else if (this.schedule[this.current_day][i].time_start !== shift.time_start
        && this.schedule[this.current_day][i].time_end > shift.time_end ||
        this.schedule[this.current_day][i].time_end > shift.time_start) {

        $('#dontInsertTurnEnd').modal('toggle');
        append = false;
        break;

      } else if (this.schedule[this.current_day][i].time_start > shift.time_start) { //inserts the shift in order
        append = false;
        this.schedule[this.current_day].splice(i, 0, shift);
        break;
      }

    }

    if (append) { // inserts the shift at the end
      this.schedule[this.current_day].push(shift);
    }

    //this.load = false;
    this.spinner.hide();
    $('#shift-new').modal('toggle');

  }

  onDeleteShift(day: string, id: number) {

    this.schedule[day].splice(id, 1);


  }

  openCreateShift(id: string) {
    this.current_day = id;
    $('#shift-new').modal('toggle'); // open modal

  }

  onCancelSchedule() {
    if (this.admin_schedules) {
      this.mostrarListaOut.emit(null);
    } else {
      this._router.navigate(['./admin/schedules/list']);
    }

  }


  private inicializedObject() {
    this.schedule.monday = [];
    this.schedule.tuesday = [];
    this.schedule.wednesday = [];
    this.schedule.thursday = [];
    this.schedule.friday = [];
    this.schedule.saturday = [];
    this.schedule.sunday = [];

    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      selectType: [0, [Validators.required, Validators.min(1)]]
    });

    this.form2 = this.fb.group({
      start_hour: ['01', [Validators.required]],
      start_min: ['00', [Validators.required]],
      end_hour: ['01', [Validators.required]],
      end_min: ['00', [Validators.required]]
    });
  }


  getSchedulesTypes(data: any) {
    //this.load = true;
    this.spinner.show(); 
    this._scheduleService.getScheduleTypes(data).subscribe(
      data => {
        this.logger.log(data);
        if (data.status) {
          this.types = data.data;
          this.types.push({ id: 0, name: 'Seleccione..' });
          console.log("Types ", this.types);
        } else {
          this.types = [{ id: 0, name: 'Seleccione..' }, 
          { id: 0, name: 'Seleccione..' }, { id: 1, name: 'Regular' }, { id: 2, name: 'Emergencia' }];
          this.toastr.error(data.message, 'Error');
        }
        //this.load = false;
        this.spinner.hide();
      },
      error => {
        this.logger.log(error);
        // this.load = false;
        this.spinner.hide();
      });
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/schedule-new/schedule-new.component.ts